<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ded">
<p class="ded"><a class="page" id="pv"></a><i>For</i> <span class="sm">SIEGMUND</span> <span class="sm">LEVARIE</span>, <i>who lived every moment in this music</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-kramer-0005.vue?ce6157b0